import { t } from 'ttag';

import { FullTaskRoute, TaskDocumentType } from 'api/api';

import {
  fetchTaskDocumentPreview,
  fetchTaskRouteDocumentPreview,
} from 'api/documentPreview.api';

export enum TaskFilterDateVariant {
  duration = 'duration',
  today = 'today',
  last7Days = 'last7Days',
  last30Days = 'last30Days',
  last90Days = 'last90Days',
}

export const isTaskFilterDateVariant = (
  value: string,
): value is TaskFilterDateVariant =>
  Object.values(TaskFilterDateVariant).includes(value as TaskFilterDateVariant);

export const TASKS_FILTER_DATE_VARIANTS = [
  {
    value: TaskFilterDateVariant.duration,
    label: t`Період`,
  },
  {
    value: TaskFilterDateVariant.today,
    label: t`Сьогодні`,
  },
  {
    value: TaskFilterDateVariant.last7Days,
    label: t`Останні 7 днів`,
  },
  {
    value: TaskFilterDateVariant.last30Days,
    label: t`Останній 30 днів`,
  },
  {
    value: TaskFilterDateVariant.last90Days,
    label: t`Останній 90 днів`,
  },
];

export function buildStartDateByVariant(
  dateVariant: TaskFilterDateVariant,
): Date | never {
  const now = new Date();

  switch (dateVariant) {
    case TaskFilterDateVariant.today:
      return now;
    case TaskFilterDateVariant.last7Days:
      return new Date(now.setDate(now.getDate() - 7));
    case TaskFilterDateVariant.last30Days:
      return new Date(now.setDate(now.getDate() - 30));
    case TaskFilterDateVariant.last90Days:
      return new Date(now.setDate(now.getDate() - 90));
    default:
      throw new Error('Unknown date variant');
  }
}

export const TASK_LIST_PAGINATION_PAGE_SIZE = 20;

export function fetchTaskDocumentPreviewBlob(
  taskId: Nullable<string>,
  documentId: Nullable<string>,
  routeId?: Nullable<string>,
) {
  if (!taskId) return Promise.resolve(null);

  if (documentId) {
    return fetchTaskDocumentPreview(taskId, documentId);
  }

  if (routeId) {
    return fetchTaskRouteDocumentPreview(taskId, routeId);
  }

  return Promise.resolve(null);
}

export const buildDocumentName = (route: FullTaskRoute): string => {
  switch (route.task_template_document?.document_type) {
    case TaskDocumentType.Application:
      return t`Заява на відпустку`;
    case TaskDocumentType.Order:
      return t`Наказ про надання відпустки`;
    default:
      return t`Редагувати документ`;
  }
};
